import request from '../request';

export default {
  //热点-列表
  lists(data) {
    return request.get('/spot/lists', data);
  },

  //热点-详情
  detail(data) {
    return request.get('/spot/detail', data);
  },

  //热点-添加
  add(data) {
    return request.post('/spot/add', data);
  },

  //热点-修改
  edit(data) {
    return request.post('/spot/edit', data);
  },

  //热点-删除
  delete(data) {
    return request.post('/spot/delete', data);
  },

  //热点-更新
  update(data) {
    return request.post('/spot/update', data);
  },

  updateSite(data) {
    return request.post('/spot/updateSite', data);
  },
};
